import toArray from 'lodash/toArray';
import memoizeLast from '../../helpers/memoizeLast';

const createRtcStatsReportParser = () =>
  memoizeLast((rtcStatsReport) => {
    let stats = [];
    if (typeof rtcStatsReport.result !== 'function') {
      // Firefox <= 45 can't use rtcStatsReport.values OPENTOK-32755
      if (typeof rtcStatsReport.values === 'function') {
        stats = toArray(rtcStatsReport.values());
      } else if (typeof rtcStatsReport.forEach !== 'function') {
        stats = Object.keys(rtcStatsReport).map(key => rtcStatsReport[key]);
      } else {
        rtcStatsReport.forEach((rtcStats) => {
          stats.push(rtcStats);
        });
      }
    } else {
      rtcStatsReport.result().forEach((rtcStat) => {
        const stat = {};

        rtcStat.names().forEach((name) => {
          stat[name] = rtcStat.stat(name);
        });

        // fake the structure of the "new" RTC stat object
        stat.id = rtcStat.id;
        stat.type = rtcStat.type;
        stat.timestamp = rtcStat.timestamp;
        stats.push(stat);
      });
    }
    return stats;
  });

export default createRtcStatsReportParser;
